import React from 'react';
import {Card, Grid, Popup, List, Icon} from 'semantic-ui-react';
import moment from 'moment';

const CalendarGrid = ({months, filteredAgendas, selectedCourseId, onCourseSelect, statusDict}) => {
  const getDayContent = (day, monthIndex, year) => {
    const current = moment.utc([year, monthIndex, day]).startOf('day');
    const dayAgendas = filteredAgendas.filter((ag) => {
      const start = moment.utc(ag.start_date || ag.desde).startOf('day');
      const end = moment.utc(ag.end_date || ag.hasta).startOf('day');
      return current.isSameOrAfter(start) && current.isSameOrBefore(end);
    });
    if (dayAgendas.length === 0) {
      return <span>{day}</span>;
    }
    const isHigh = selectedCourseId && dayAgendas.some((a) => Number(a.id) === Number(selectedCourseId));
    return (
      <Popup
        basic inverted position="top center"
        trigger={
          <div style={{
            'position': 'relative', 'cursor': 'pointer', 'fontWeight': 'bold', 'color': 'white',
            'backgroundColor': isHigh ? '#2185d0' : '#8f8f8f99', 'borderRadius': '2px',
            'width': '100%', 'height': '28px', 'display': 'flex', 'alignItems': 'center', 'justifyContent': 'center',
          }}>
            {day}
            <div style={{
              'display': 'flex', 'justifyContent': 'center', 'gap': '3px', 'position': 'absolute',
              'bottom': '3px', 'width': '100%',
            }}>
              {dayAgendas.map((ag, idx) => (
                <div
                  key={`${ag.id}-${idx}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    onCourseSelect(Number(selectedCourseId) === Number(ag.id) ? null : ag.id);
                  }}
                  style={{
                    'width': '10px', 'height': '10px', 'borderRadius': '50%', 'border': '1px solid white',
                    'backgroundColor': statusDict.find((s) => s.code === ag.status)?.hex || '#fff',
                    'cursor': 'pointer',
                  }}
                />
              ))}
            </div>
          </div>
        }
        content={
          <List size="mini" divided>
            {dayAgendas.map((ag) => (
              <List.Item key={ag.id} onClick={() => onCourseSelect(Number(selectedCourseId) === Number(ag.id) ?
                null : ag.id)} style={{'cursor': 'pointer'}}>
                <Icon name="tag" style={{
                  'color': statusDict.find((s) => s.code === ag.status)?.hex || '#ccc',
                }} />
                <List.Content><List.Header style={{'fontSize': '0.85em'}}>{ag.nombre_curso}</List.Header></List.Content>
              </List.Item>
            ))}
          </List>
        }
      />
    );
  };
  return (
    <Card raised fluid style={{'padding': '1em', 'overflowY': 'auto', 'maxHeight': '75vh'}}>
      <Grid columns={3} doubling stackable>
        {months.map((mes) => (
          <Grid.Column key={mes.name} style={{'marginBottom': '1.5em'}}>
            <div style={{'textAlign': 'center', 'fontWeight': 'bold', 'padding': '5px',
              'background': 'rgba(125, 188, 240, 1)'}}>
              {mes.name} {mes.year}
            </div>
            <div style={{'display': 'grid', 'gridTemplateColumns':
               'repeat(7, 1fr)', 'border': '1px solid #ddd'}}>
              {['D', 'L', 'M', 'X', 'J', 'V', 'S'].map((d) => (
                <div key={d} style={{'textAlign': 'center', 'fontSize': '0.7em',
                  'background': 'rgba(125, 188, 240, 0.2)'}}>{d}</div>
              ))}
              {Array(mes.firstDay).fill(null).map((_, i) => (
                <div key={i} style={{'background': '#fcfcfc', 'border': '0.1px solid #f0f0f0'}} />
              ))}
              {Array.from({'length': mes.daysInMonth}, (_, i) => (
                <div key={i} style={{
                  'textAlign': 'center', 'border': '0.1px solid #eee', 'minHeight': '35px', 'display': 'flex',
                  'alignItems': 'center', 'justifyContent': 'center',
                }}>
                  {getDayContent(i + 1, mes.monthIndex, mes.year)}
                </div>
              ))}
            </div>
          </Grid.Column>
        ))}
      </Grid>
    </Card>
  );
};

export default CalendarGrid;
